import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ModalName } from 'ff/debrief/models';

export interface ModalState {
    modals: { [k in ModalName]: boolean };
}

const initialModalState: ModalState = {
    modals: {
        LinkLogbook: false,
        OtherInfo: false,
        Downloads: false,
        DeleteTracklog: false,
        Share: false,
        RemoveShare: false,
        SharedDownload: false,
        SharedOtherInfo: false,
        Vspeed: false,
        Imports: false,
    },
};

export const modalSlice = createSlice({
    name: 'ModalSlice',
    initialState: initialModalState,
    reducers: {
        openModal: (state, action: PayloadAction<ModalName>) => {
            state.modals[action.payload] = true;
        },
        closeModal: (state, action: PayloadAction<ModalName>) => {
            state.modals[action.payload] = false;
        },
    },
});

export const { openModal, closeModal } = modalSlice.actions;
